import React from 'react'
import Layout from 'components/Layout'
import ScreenShell from 'components/ScreenShell/ScreenShell'
import Admin from './components/Admin'

const Admin_Index = () => {
	return (
		<ScreenShell>
		<Layout>
			<Layout.Page>
				<Layout.Sidebar>
					<Layout.SidebarUserCard />
				</Layout.Sidebar>
				<Layout.Body>
					<Layout.PageHeader>
						<h2>Admin Tools</h2>
					</Layout.PageHeader>
					<Admin />
				</Layout.Body>
			</Layout.Page>
		</Layout>
		</ScreenShell>
	)
}

export default Admin_Index
